export default "__VITE_ASSET__BwdVfu5N__"